import { useState, useEffect } from 'react';

const POSTER_URL =
  'https://storage.readdy-site.link/project_files/c65d8bd8-1a8a-4037-9aa9-99de95725db5/7554d6c1-c1a6-47e5-a272-e4d2ab9899e7_INS-PRO-CLASS-POSTER-1080-x-1350-px.jpeg?v=6bc6069c35688e26444d5deb60a37b7a';

export default function PopupBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 600);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(0,0,0,0.70)' }}
      onClick={() => setVisible(false)}
    >
      <div
        className="relative animate-popup"
        style={{ maxWidth: '420px', width: '100%' }}
        onClick={e => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={() => setVisible(false)}
          className="absolute top-3 right-3 z-10 w-8 h-8 bg-black/50 hover:bg-black/80 rounded-full flex items-center justify-center transition-all cursor-pointer"
        >
          <i className="ri-close-line text-white text-lg" />
        </button>

        {/* Poster image */}
        <div className="w-full rounded-2xl overflow-hidden">
          <img
            src={POSTER_URL}
            alt="INS Pro Class Poster"
            className="w-full h-auto block object-top"
            style={{ display: 'block' }}
          />
        </div>

        {/* Dismiss hint */}
        <p
          className="text-center text-white/60 text-xs mt-3 cursor-pointer hover:text-white/90 transition-colors"
          onClick={() => setVisible(false)}
        >
          Tap anywhere to close
        </p>
      </div>

      <style>{`
        @keyframes popupIn {
          from { opacity: 0; transform: scale(0.88); }
          to   { opacity: 1; transform: scale(1); }
        }
        .animate-popup {
          animation: popupIn 0.35s ease-out forwards;
        }
      `}</style>
    </div>
  );
}
